import { core } from '@icc/shared/helpers/b2b';

export function formatCurrency(value: number | null, locale: string, currency: any): string | null {
    if (value == null) {
        return null;
    }
    if (!currency) {
        return null;
    }
    if (!currency.custom_format) {
        const formatter = Intl.NumberFormat(locale, {
            currency: currency.code,
            style: 'currency'
        });
        return formatter.format(value);
    }
    if (currency.position === 'before') {
        return currency.symbol + core.formatNumber(value, 2, 3, currency.thousands ?? '.', currency.decimals ?? ',');
    } else {
        return core.formatNumber(value, 2, 3, currency.thousands ?? '.', currency.decimals ?? ',') + ' ' + currency.symbol;
    }
}